import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'
import * as apps from '../apps'
import * as contexts from '../contexts'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Enables management of user assignments for specific entities such as tenants,
 * zones, or applications.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ApiService} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    const contextsFeature = ngCore.inject(contexts.Feature)
    const meFeature = ngCore.inject(me.Feature)
    const appsEc = ngCore.inject(apps.Collection)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'AdminUserAssignment',
      selectors: () => new Selectors(this, contextsFeature, meFeature, appsEc),
    })
    this.registerEffects(
      effects.getUsersOnRequest(),
      effects.requestUsersForAssignment(contextsFeature, meFeature),
      effects.assignAccessOnRequest(),
    )
  }
}
